const auth = {
  loading: false,
  user: {},
  error: null,
};

export default auth;
